import { styled } from '@nykaa/ui-components';
import { DWEB_MAX_WIDTH, BREAKPOINTS } from 'shared/styles/base';

export const Wrapper = styled.article`
  width: 100%;
  padding: ${({ theme }) => `0 ${theme.spacing.spacing50}`};

  & a[href] {
    color: ${({ theme }) => theme.colors.secondary};
    text-decoration: underline;
    margin: ${({ theme }) => `0 ${theme.spacing.spacing10}`};
  }

  @media screen and (min-width: ${BREAKPOINTS.DESKTOP}px) {
    max-width: ${DWEB_MAX_WIDTH}px;
    margin: ${({ theme }) => `${theme.spacing.spacing40} auto ${theme.spacing.spacing100}`};
  }
`;
